import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'
import { RTC_STATE } from "../api/enums.js"

export default defineStore('userStore', {
	state: () => {
		return {
			userInfo: {},
			isInRtc: false // 是否正在通话中
		}
	},
	actions: {
		setUserInfo(userInfo) {
			this.userInfo = userInfo
		},
		/** 切换在线状态成功后写入全局用户信息（与 Header / HeadImage 约定：1在线 2挂起 3忙碌 4离线） */
		applyOnlineStatus(status) {
			const n = Number(status)
			if (Number.isNaN(n) || n < 1 || n > 4) return
			const prev = this.userInfo || {}
			this.userInfo = {
				...prev,
				onlineStatus: n,
				online: n !== 4
			}
		},
		setInRtc(isInRtc) {
			this.isInRtc = isInRtc;
		},
		clear() {
			this.userInfo = {};
			this.rtcInfo = {
				friend: {},
				mode: "video",
				state: RTC_STATE.FREE
			};
		},
		loadUser() {
			return new Promise((resolve, reject) => {
				http({
					url: '/user/self',
					method: 'GET'
				}).then((userInfo) => {
					this.setUserInfo(userInfo);
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		}
	}
});